<template>
  <v-container fluid class="folding--menu">

    <v-row no-gutters :class="{'flex-nowrap': $vuetify.breakpoint.lgAndUp}">

      <div class="menu--section menu--title">

        <div v-if="welcome" class="header2">

          <template v-if="firstLogin">Herzlich Willkommen<br>im Makler-Portal.
          </template>
          <template v-else>Herzlich Willkommen zurück.
          </template>
          <br>
          {{ $store.getters.nameForMenu }}

          <div class="header1 username">{{ $store.getters.user.name }}
          </div>
          <div v-if="$store.getters.user.vmnr" class="header1">{{ $store.getters.user.vmnr }}
          </div>

        </div>

        <div v-else class="header1">{{ title }}
        </div>
      </div>

      <v-row no-gutters class="pr-6 flex-nowrap">
        <v-col xs="6" class="menu--section menu--items">
          <v-row no-gutters>
            <template v-for="(item, index) in items">
              <v-col v-if="index < lineBreak"
                   :key="index"
                   cols="12"
                   class="router--link no--touchstart"
                   @click="$emit('navigate', item.path)">
                <div :class="{'first': index === 0}"
                     class="header2">{{ item.title }}
                </div>
                <div class="menu--text">{{ item.description }}</div>
              </v-col>
            </template>
          </v-row>
        </v-col>

        <v-col xs="6" class="menu--section menu--items">
          <v-row no-gutters>
            <template v-for="(item, index) in items">
              <v-col v-if="index >= lineBreak"
                   :key="index"
                   cols="12"
                   class="router--link no--touchstart"
                   @click="$emit('navigate', item.path)">
                <div :class="{'first': index === lineBreak}"
                     class="header2">{{ item.title }}
                </div>
                <div class="menu--text">{{ item.description }}</div>
              </v-col>
            </template>
          </v-row>
        </v-col>
      </v-row>

      <div class="menu--section menu--support bg-dimmed">

        <div class="header1">Service
        </div>

        <v-row no-gutters class="fill-parent flex-grow-0">
          <v-col xs="6" lg="12">
            <div class="support-header mb-2">{{ maklerService.type }}-Hotline</div>
            <a :href="'tel:' + maklerService.phoneClickable"><div class="menu--text">{{ maklerService.phone }}</div></a>
            <div class="menu--text">{{ maklerService.time }}</div>
            <div><a class="no--touchstart" @click="$emit('navigate', '/vertriebsunterstuetzung/maklerservice')">mehr</a></div>
          </v-col>
          <v-col xs="6" lg="12">
            <div class="support-header">{{ rechtService.type }}-Hotline</div>
            <div class="menu--text mb-2">{{ rechtService.subtitle }}</div>
            <a :href="'tel:' + rechtService.phoneClickable"><div class="menu--text">{{ rechtService.phone }}</div></a>
            <div class="menu--text">{{ rechtService.time }}</div>
            <div><a class="no--touchstart" @click="$emit('navigate', '/soforthilfe')">mehr</a></div>
          </v-col>
        </v-row>

        <div class="footnote">*{{ rechtService.footnote }}</div>

      </div>

    </v-row>

    <div class="grey--frame bg-dimmed">&nbsp;</div>

  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: "FoldingMenu",
  props: {
    title: {
      type: String,
      required: true
    },
    welcome: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      required: true
    }
  },
  computed: {
    lineBreak() {
      return Math.floor(this.items.length / 2);
    },
    maklerService() {
      return this.$store.state.staticPagesContent.AboutUnternehmenMaklerBox;
    },
    rechtService() {
      return this.$store.state.staticPagesContent.VertriebMaklerServiceSidebar.filter(c => c.type==="DMB RECHT")[0];
    },
    ...mapGetters(['firstLogin'])
  },
  mounted () {
    //initilize style.top (of parent DOM Element). It will only be changed by JS, though it must be initialized by JS not CSS
    let top = document.getElementById("contentInner").classList.contains("scroll-down") ? "48px" : "136px";
    let menus = document.getElementsByClassName("menu-content-open");
    Array.prototype.forEach.call(menus, function (menu) {
      menu.style.position = "absolute";
      menu.style.top = top;
      });
    let links = document.getElementsByClassName("no--touchstart");
    Array.prototype.forEach.call(links, function(link) {
      link.addEventListener('touchstart', function (e) {
        e.stopPropagation();
      });
    });
  }
};
</script>
<style>
.folding--menu {
  max-width: 1280px;
  width: 1280px;
  height: 384px;
  padding: 64px 88px 40px 88px;
}

.folding--menu .menu--section {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  height: 100%;
}

.folding--menu .menu--title {
  width: 240px;
  min-width: 240px;
  flex-direction: column;
}

.folding--menu .menu--title .header2 .header1 {
  margin-top: 8px;
}


.folding--menu .menu--title .header1.username {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

.folding--menu .menu--items {
  position: relative;
  width: 248px;
  min-width: 248px;
  max-width: 248px;
  height: 100%;
}

.folding--menu .menu--items .router--link {
  cursor: pointer;
}

.folding--menu .menu--items .router--link:hover .header2, .folding--menu .menu--items .router--link:hover .menu--text {
  color: #0085CF !important;
}

.folding--menu .menu--items div {
  width: 100%;
}

.folding--menu .menu--section + .menu--section, .folding--menu .menu--section + div .menu--section {
  margin-left: 40px !important;
}

.folding--menu .header1 {
  font-size: 24px !important;
  font-weight: 400;
  color: #002C76;
}

.folding--menu .header2 {
  font-size: 16px;
  font-weight: 500;
  color: rgba(0, 0, 0, .87);
  margin: 0 0 8px 0;
  width: 100%;
}

.folding--menu .support-header {
  font-size: 16px;
  font-weight: 400;
  color: rgba(0, 0, 0, .87);
  margin: 20px 0 0 0;
  width: 100%;
}

.folding--menu .menu--items .header2:not(.first)::before {
  display: block;
  content: "";
  border-top: 1px solid rgba(0, 0, 0, .38);
  width: 100%;
  margin: 16px 0 20px 0;
}

.folding--menu .menu--text {
  font-size: 14px;
  font-weight: normal;
  color: rgba(0, 0, 0, .38);
  white-space: nowrap;
  overflow: visible;
}

.folding--menu .grey--frame {
  display: none;
}

@media screen and (min-width: 1264px) {
  .folding--menu .grey--frame {
    display: block !important;
    position: absolute;
    top: 0;
    right: 0;
    height: 384px;
    width: calc((100vw - 1280px) / 2 + 248px);
  }

  .footnote {
    font-size: xx-small;
    color: rgba(0, 0, 0, .38);
    position: absolute;
    right: 20px;
    bottom: 10px;
  }

  .folding--menu .menu--support {
    margin: -64px 0 0 0;
    padding: 64px 40px 0 40px;
    min-width: 248px;
    max-width: 286px!important;
    height: 384px;
    z-index: 30;
    flex-direction: column;
  }
}

@media screen and (max-width: 1263px) {
  .folding--menu {
    height: fit-content;
    width: 100%;
  }

  .folding--menu .menu--title {
    display: none;
  }

  .folding--menu .menu--section {
    padding-bottom: 64px !important;
  }

  .folding--menu .menu--section + .menu--section {
    margin-right: 40px !important;
  }

  .folding--menu .menu--support {
    margin: 40px 0 0 0 !important;
    padding: 40px !important;
    height: auto;
    flex-direction: column;
  }

  .footnote {
    font-size: xx-small;
    color: rgba(0, 0, 0, .38);
    position: absolute;
    right: 96px;
    bottom: 48px;
  }

  .folding--menu .menu--support {
    width: 100%;
  }
}

@media screen and (max-width: 730px) {
  .folding--menu .menu--support .header2, .folding--menu .menu--support .menu--text {
    height: 42px;
  }
}
</style>
